import { Star, TrendingUp } from 'lucide-react';

const StatsTab = ({ seller }) => {
  return (
    <>
      {/* Performance Stats */}
      <div className='bg-card border border-border rounded-lg p-6'>
        <h2 className='text-lg font-semibold mb-4 flex items-center'>
          <TrendingUp className='mr-2' size={20} />
          Performance Statistics
        </h2>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4'>
          <div className='bg-accent/50 rounded-lg p-4'>
            <label className='text-xs text-muted-foreground'>
              Total Bookings
            </label>
            <p className='text-2xl font-bold mt-1'>
              {seller?.stats?.totalBookings || 0}
            </p>
          </div>
          <div className='bg-accent/50 rounded-lg p-4'>
            <label className='text-xs text-muted-foreground'>
              Completed Bookings
            </label>
            <p className='text-2xl font-bold mt-1'>
              {seller?.stats?.completedBookings || 0}
            </p>
          </div>
          <div className='bg-accent/50 rounded-lg p-4'>
            <label className='text-xs text-muted-foreground'>
              Cancelled Bookings
            </label>
            <p className='text-2xl font-bold mt-1'>
              {seller?.stats?.cancelledBookings || 0}
            </p>
          </div>
          {/* <div className='bg-accent/50 rounded-lg p-4'>
            <label className='text-xs text-muted-foreground'>Acceptance Rate</label>
            <p className='text-2xl font-bold mt-1'>{seller?.stats?.acceptanceRate || 0}%</p>
          </div> */}
          {/* <div className='bg-accent/50 rounded-lg p-4'>
            <label className='text-xs text-muted-foreground'>Completion Rate</label>
            <p className='text-2xl font-bold mt-1'>{seller?.stats?.completionRate || 0}%</p>
          </div> */}
          {/* <div className='bg-accent/50 rounded-lg p-4'>
            <label className='text-xs text-muted-foreground'>Response Time</label>
            <p className='text-2xl font-bold mt-1'>{seller?.stats?.responseTime || 0} min</p>
          </div> */}
          {/* <div className='bg-accent/50 rounded-lg p-4'>
            <label className='text-xs text-muted-foreground'>On-Time Delivery</label>
            <p className='text-2xl font-bold mt-1'>{seller?.stats?.onTimeDeliveryRate || 0}%</p>
          </div> */}
          <div className='bg-accent/50 rounded-lg p-4'>
            <label className='text-xs text-muted-foreground'>Rating</label>
            <div className='flex items-center mt-1'>
              <Star size={20} className='text-yellow-500 fill-yellow-500' />
              <p className='text-2xl font-bold ml-2'>
                {seller?.sellerRating?.toFixed(1) || 'N/A'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StatsTab;
